import { styled } from "@vitality-ds/system";
import BasePrimitiveSkeletonBoxStyles from "./styles/BasePrimitiveSkeletonBox";

// eslint-disable-next-line import/prefer-default-export
export var BasePrimitiveSkeletonBox = styled("div", BasePrimitiveSkeletonBoxStyles);